<template>
  <v-app id="inspire">
    <tool-bar>
      <slot><h3>Online Visa Processing </h3></slot>
    </tool-bar>


    <v-content class="pt-0">
      <v-container fluid>
        <v-layout justify-center>
          <v-card>
            <v-card-text class="pa-0">
              <v-tabs
                  background-color="primary"
                  centered
                  dark
                  fixed-tabs
                  slider-color="orange" v-model="extendConvertTab">
                <v-tabs-slider color="blue lighten-2"/>
                <v-tab href="#tab-extend"
                       v-if="extendConvertVisaDetail && extendConvertVisaDetail.extendable && $store.state.VisaSingle.can_extend">
                  <v-icon left>mdi-alpha-e-box</v-icon>
                  Visa Extension
                </v-tab>

                <v-tab href="#tab-change"
                       v-if="(showConversion || belowTenYear) && $store.state.VisaSingle.can_convert">
                  <v-icon left>mdi-alpha-c-box</v-icon>
                  Visa Conversion
                </v-tab>
                <v-tab href="#tab-overstay-regulation"
                       v-if="extendConvertVisaDetail && extendConvertVisaDetail.extendable && $store.state.VisaSingle.can_overstay_regulation">
                  <v-icon left>mdi-alpha-o-box</v-icon>
                  Overstay regulation
                </v-tab>
                <v-tab href="#tab-arrival" v-if="showCertification">
                  <v-icon left>mdi-alpha-a-box</v-icon>
                  Certifications
                </v-tab>
                <v-tab href="#tab-transfer" v-if="showTransfer">
                  <v-icon left>mdi-alpha-e-box</v-icon>
                  Visa transfer
                </v-tab>
                <v-tab href="#tab-upgrade" v-if="showPlanUpgrade">
                  <v-icon left>mdi-alpha-p-box</v-icon>
                  Visa plan upgrade
                </v-tab>
                <v-tab href="#tab-overstay-regulation-special"
                       v-if="showOverstayRegulationSpecial">
                  <v-icon left>mdi-alpha-s-box</v-icon>
                 Overstay regulation (NT)
                </v-tab>


                <v-tab-item :value="'tab-extend'"
                            v-if="extendConvertVisaDetail && extendConvertVisaDetail.extendable && $store.state.VisaSingle.can_extend">
                  <extend-form/>
                </v-tab-item>
                <!--                <v-tab-item :value="'tab-extend'"-->
                <!--                            v-if="extendConvertVisaDetail && extendConvertVisaDetail.extendable && !$store.state.VisaSingle.can_extend">-->
                <!--                  <h1 class="ma-12 text-center" style="color: red">Your current visa cannot be extend.Please contact administrator section</h1>-->
                <!--                </v-tab-item>-->
                <v-tab-item :value="'tab-overstay-regulation'"
                            v-if="extendConvertVisaDetail && extendConvertVisaDetail.extendable && $store.state.VisaSingle.can_overstay_regulation">
                  <overstay-form/>
                </v-tab-item>

                <v-tab-item :value="'tab-change'"
                            v-if="(showAllActions || showConversion) && $store.state.VisaSingle.can_convert">
                  <v-card-text class="pb-0">
                    <v-layout row wrap class="mx-0">
                      <v-flex xs12>
                        <v-form ref="convertForm">
                          <v-layout class="px-4 pt-2" row wrap>
                            <v-flex class="pr-2" xs12 v-if="showAppointment">
                              <appointment-date-picker
                                  v-model="extendConvertData.appointment_date"
                                  :type="selected_visa_type"/>
                            </v-flex>
                            <confirmation-header-text class="mx-0 mt-2 mb-3"
                                                      text="Convert Details"
                                                      icon="mdi-equal-box"/>

                            <v-flex xs12 sm4>
                              <v-autocomplete
                                  :items="convert_visa_options"
                                  :rules="[rules.required]"
                                  class="pr-2"
                                  item-text="type"
                                  item-value="id"
                                  label="Convert Visa to *"
                                  outlined
                                  v-model="extendConvertData.visa_type">
                              </v-autocomplete>
                            </v-flex>
                                <v-flex xs12 sm4 v-if="extendConvertData.visa_type===1 || extendConvertData.visa_type===19 || extendConvertData.visa_type===37">
                               <v-text-field
                                  :rules=[rules.required]
                                  label="Application Number from Department Of Industry*"
                                  outlined
                                  type="text"
                                  v-model="extendConvertData.application_number"
                              />
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-autocomplete
                                  :items="reason_for_conversion"
                                  :label="$vuetify.lang.t('$vuetify.reason_for_convert') + ' *'"
                                  :rules=[rules.required]
                                  outlined
                                  v-model="extendConvertData.purpose_of_visa"
                              />
                            </v-flex>
                            <v-flex class="pl-2" xs12 sm4>
                              <v-text-field
                                  :rules=[rules.required,rules.mobileNumberLength]
                                  label="Mobile number of Nepal *"
                                  outlined
                                  type="number"
                                  v-model="extendConvertData.mobile_number"
                              />
                            </v-flex>
                            <v-flex xs12 sm4>
                              <v-text-field
                                  :label="$vuetify.lang.t('$vuetify.email_required')"
                                  :rules="[rules.required, rules.email]"
                                  id="email"
                                  outlined
                                  type="email"
                                  autocomplete="off"
                                  placeholder="Application notification will be sent to this email"
                                  v-model="extendConvertData.email"
                              />
                            </v-flex>

                            <v-flex xs12
                                    v-if="isDependent && !['dependent-diplomatic-visa','dependent-official-visa'].includes(visaSlug)">
                              <v-checkbox :value=1 v-model="extendConvertData.isIndianHost"
                                          label="Is Host Indian/Nepali?"></v-checkbox>
                            </v-flex>
                            <v-flex
                                v-if="isDependent && (!['dependent-diplomatic-visa','dependent-official-visa'].includes(visaSlug) && extendConvertData.isIndianHost !== 1)"
                                xs6>
                              <v-text-field
                                  :label="$vuetify.lang.t('$vuetify.dependent_visa_number') +'*'"
                                  :rules="[rules.required]"
                                  class="pr-2"
                                  outlined
                                  type="text"
                                  v-model="extendConvertData.dependent_visa_number"
                              />
                            </v-flex>
                            <v-flex xs6 v-if="isDependent">
                              <v-text-field
                                  :label="$vuetify.lang.t('$vuetify.dependent_passport_number') + '*'"
                                  :rules="[rules.required]"
                                  class="pr-2"
                                  outlined
                                  type="text"
                                  v-model="extendConvertData.dependent_passport_number"
                              />
                            </v-flex>
                          </v-layout>
                        </v-form>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="d-flex justify-end">

                    <v-btn
                        @click="back"
                        color="error"
                        dark
                        large
                    >{{ $vuetify.lang.t('$vuetify.back') }}
                    </v-btn>
                    <v-btn @click="proceedExchange"
                           class="mr-3"
                           color="primary"
                           large
                           :loading="loading"
                    >
                      {{ $vuetify.lang.t('$vuetify.proceed') }}
                    </v-btn>
                  </v-card-actions>

                </v-tab-item>
                <!--                <v-tab-item :value="'tab-change'"-->
                <!--                            v-if="(showAllActions || showConversion) && !$store.state.VisaSingle.can_convert">-->
                <!--                  <h1 class="ma-12 text-center" style="color: red">Your current visa cannot be convert.Please contact administrator section</h1>-->
                <!--                </v-tab-item>-->
                <v-tab-item :value="'tab-transfer'" v-if="showTransfer">
                  <visa-transfer-form/>
                </v-tab-item>
                <v-tab-item :value="'tab-arrival'" v-if="showCertification">
                  <arrival-certification-form :countries="countries"
                                              :offices="offices"/>
                </v-tab-item>
                <v-tab-item :value="'tab-upgrade'" v-if="showPlanUpgrade">
                  <plan-upgrade-form/>
                </v-tab-item>

                <v-tab-item :value="'tab-overstay-regulation-special'"
                            v-if="showOverstayRegulationSpecial">
                  <overstay-regulation-special-form/>
                </v-tab-item>
              </v-tabs>
              <v-flex xs12>
                <v-divider class="mt-3"/>
              </v-flex>
              <visa-detail :visa="extendConvertVisaDetail"/>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import VisaDetail from "./VisaDetail";
import {validationMixin} from "../mixins/validationMixin";
import ToolBar from "../components/ToolBar";
import ArrivalCertificationForm from "./certification/ArrivalCertificationForm";
import VisaTransferForm from "./convert/VisaTransferForm";
import PlanUpgradeForm from "./plan/PlanUpgradeForm";
import {fetchDynamicValues} from "../helpers/dynamicValueHelper";
import ExtendForm from "./extend/ExtendForm";
import AppointmentDatePicker from "../components/AppointmentDatePicker";
import ConfirmationHeaderText from "../components/ConfirmationHeaderText";
import Http from "axios";
import {API_URL, VERSION} from "../config/config";
import OverstayForm from "./OverstayForm";
import OverstayRegulationSpecialForm from "./OverstayRegulationSpecialForm";

import moment from "moment/src/moment";

export default {
  data() {
    return {
      loading: false,
      extendConvertTab: 'tab-extend',
      reason_for_extension: [],
      reason_for_conversion: []
    };
  },
  mixins: [validationMixin],
  components: {
    OverstayForm,
    AppointmentDatePicker,
    ConfirmationHeaderText,
    ExtendForm,
    VisaDetail,
    ToolBar,
    ArrivalCertificationForm,
    VisaTransferForm,
    PlanUpgradeForm,
    OverstayRegulationSpecialForm,
  },
  computed: {
    ...mapGetters('VisaSingle', ['visaTransferData', 'extendConvertData', 'extendConvertVisaDetail', 'arrivalDepartureCertification', 'selectedTab']),
    ...mapGetters('VisaType', ['visa_type_slug']),
    ...mapGetters({
      countries: 'CountryForTouristList/all',
    }),
    showOverstayRegulationSpecial(){
      return this.extendConvertVisaDetail && this.extendConvertVisaDetail.extendable && this.$store.state.VisaSingle.can_overstay_regulation &&
          (this.extendConvertVisaDetail.late_days > 0 || this.extendConvertVisaDetail.overstayed > 0)
    },
    showAppointment() {
      const selected_office = this.offices.find(i => i.slug === this.$store.state.VisaSingle.office)
      this.extendConvertTab = this.$store.state.VisaSingle.extendConvertTab;
      return selected_office.token_system_active;
    },
    selected_visa_type() {
      const selected_visa_type = this.convert_visa_options.find(i => i.id === this.extendConvertData.visa_type);
      if (selected_visa_type !== undefined)
        return selected_visa_type.slug;

      return ""
    },
    isDependent() {
      const selected_visa_type = this.convert_visa_options.find(i => i.id === this.extendConvertData.visa_type);
      if (selected_visa_type !== undefined && selected_visa_type.dependent)
        return true

      return false
    },
    visaSlug() {
      const selected_visa_type = this.convert_visa_options.find(i => i.id === this.extendConvertData.visa_type);
      return selected_visa_type.slug;
    },
    showConversion() {

      // const {can_convert_to} = this.extendConvertVisaDetail;
      // if(can_convert_to.length === 1)
      //   return true;

      const office_name = this.$store.state.VisaSingle.office.toLowerCase();
      if (office_name) {
        return true;
      }
      return false;
    },
    overStayedOrLate() {
      if (this.extendConvertVisaDetail) {
        return this.extendConvertVisaDetail.late_days > 0 || this.extendConvertVisaDetail.overstayed > 0;
      }
      return false;
    },
    convert_visa_options() {
      let convert_visa_options = this.$store.state.VisaSingle.convert_visa_options.filter(item => item.slug !== this.extendConvertVisaDetail.slug);
      const {slug} = this.extendConvertVisaDetail;
      const office_name = this.$store.state.VisaSingle.office.toLowerCase();
      if (office_name === 'doi') {
        if (this.overStayedOrLate && slug !== 'consular-gratis-visa') {
          // if (this.overStayedOrLate && slug === 'tourist-visa') {
          //   return convert_visa_options.filter(i => (i.slug === 'tourist-visa' || (i.slug === 'nrn-visa')
          //       || (i.slug === 'study-visa') || (i.slug === 'non-tourist-visa-others') ));
          // }
          // if (this.overStayedOrLate && (slug === 'temporary-working-visa' || slug === 'dependent-working-visa')) {
          //   return convert_visa_options.filter(i => (i.slug === 'working-visa' || i.slug === 'tourist-visa'));
          // }
          return convert_visa_options.filter(i => this.$store.state.VisaSingle.can_convert_to.includes(i.slug));
        }
        else if ((this.$store.state.VisaSingle.can_convert_to && this.$store.state.VisaSingle.can_convert_to.length > 0) && !this.overStayedOrLate) {
          return convert_visa_options.filter(i => this.$store.state.VisaSingle.can_convert_to.includes(i.slug));
        } else {
          return convert_visa_options.filter(i => (i.slug !== 'consular-gratis-visa' && i.slug !== 'dependent-visa'));
        }
      }
      if ((this.$store.state.VisaSingle.can_convert_to && this.$store.state.VisaSingle.can_convert_to.length > 0) && !this.overStayedOrLate) {
        return convert_visa_options.filter(i => this.$store.state.VisaSingle.can_convert_to.includes(i.slug));
      }

      if (office_name === 'io03') {
        const pokhara_office_options = ['tourist-visa', 'relation-visa', 'nrn-visa', 'marriage-visa']
        return convert_visa_options.filter((i) => pokhara_office_options.indexOf(i.slug) > -1);
      } else {
        const other_office_options = ['tourist-visa', 'relation-visa', 'nrn-visa']
        return convert_visa_options.filter((i) => other_office_options.indexOf(i.slug) > -1);
      }
    },
    offices() {
      return this.$store.state.Office.offices;
    },
    belowTenYear() {
      let dob = this.extendConvertVisaDetail.dob.substr(0, 4);
      dob = parseInt(dob) + 10;
      let current_year = new Date().getFullYear();
      return dob >= current_year;
    },
    isPassportExpired() {
      let validity = this.extendConvertVisaDetail.validity;
      if (validity < moment().format('YYYY-MM-DD')) {
        return true;
      }
      return false;
    },
    showAllActions() {
      let office_name_lower = this.$store.state.VisaSingle.office.toLowerCase();
      return office_name_lower === 'doi' || office_name_lower === 'io01';
    },
    showTransfer() {
      return this.$store.state.VisaSingle.can_visa_transfer;
      // return this.$store.state.VisaSingle.office.toLowerCase() === 'doi' || this.$store.state.VisaSingle.office.toLowerCase() === 'io03' || this.$store.state.VisaSingle.office.toLowerCase() === 'io01';
    },
    showPlanUpgrade() {
      return this.$store.state.VisaSingle.can_plan_upgrade;
      // return this.$store.state.VisaSingle.office.toLowerCase() === 'doi' || this.$store.state.VisaSingle.office.toLowerCase() === 'io03' || this.$store.state.VisaSingle.office.toLowerCase() === 'io01';
    },
    showCertification() {
      return this.$store.state.VisaSingle.can_certification;
      // return this.$store.state.VisaSingle.office.toLowerCase() === 'doi' || this.$store.state.VisaSingle.office.toLowerCase() === 'io03' || this.$store.state.VisaSingle.office.toLowerCase() === 'io01';
    },
  },
  methods: {
    ...mapActions({
      submitVisaExtend: "VisaSingle/submitExtendVisa",
      submitConvertVisa: "VisaSingle/submitConvertVisa",
      fetchConditionForConvert: 'VisaType/fetchConditionForConvert',
      fetchConditionsForExtend: 'VisaType/fetchConditionsForExtend',
      fetchAllCountries: "CountryForTouristList/fetchAll",
    }),
    async proceedExchange() {
      if (this.$refs.convertForm.validate()) {
        if (this.showAppointment) {
          const selected_visa_type = this.convert_visa_options.find(i => i.id === this.extendConvertData.visa_type);
          const selected_office = this.offices.find(i => i.slug === this.$store.state.VisaSingle.office)
          const {data: {status}} = await Http.get(`${API_URL}${VERSION}/check-if-time-available`, {
            params: {
              date: this.extendConvertData.appointment_date,
              type: selected_visa_type.slug,
              passport_number: this.extendConvertVisaDetail.passport_number,
              office: selected_office.slug
            }
          })
          if (!status) {
            this.$store.commit('Notification/showError', 'Visa appointment are already packed for this date .  Please select different date')
            return

          }

        }

        if ((this.extendConvertVisaDetail.passport_number === this.extendConvertData.dependent_passport_number) && (this.extendConvertVisaDetail.visa_number === this.extendConvertData.dependent_visa_number)) {
          this.$store.commit('Notification/showError', 'You cannot apply for dependent with yourself')
          return
        }

        try {
          this.loading = true;
          await this.fetchConditionForConvert({
            type: this.extendConvertData.visa_type
          });
          this.extendConvertData.start_date = new Date().toISOString().substr(0, 10);
          this.$router.push({
            name: 'ConvertForm'
          })
          this.loading = false
        } catch (e) {
          this.loading = false;
        }


      } else {
        this.$store.commit('Notification/showError', 'Invalid form data')
      }
    },
    back() {
      this.$router.go(-1);
    },
  }
  ,
  mounted() {
    this.fetchAllCountries();
    fetchDynamicValues('ReasonForExtension').then((data) => {
      this.reason_for_extension = data;
    });
    fetchDynamicValues('ReasonForConversion').then((data) => {
      this.reason_for_conversion = data;
    });
  },
  watch:{
    extendConvertTab: {
      handler(){
        if(this.extendConvertData.hasOwnProperty('is_special_overstay_regulation')){
          delete this.extendConvertData.is_special_overstay_regulation
          delete this.extendConvertData.special_overstay_regulation_condition
        }
      }
    }
  },
}
</script>
